import React from 'react';
import ParentLayout from "./ParentLayout";
import CourseProfile from "../tutor/CourseProfile";

const ParentCourseProfile = () => {
    return (
        <ParentLayout>
            <CourseProfile/>
        </ParentLayout>
    );
};

export default ParentCourseProfile;
